const newItem = {
  data: {
    name: 'Untitled board',
    elements: [],
    notes: [],
    jumpers: [],
    connections: [],
    branches: [],
  },
  config: {
    collapsed: true,
    transform: {
      scale: 1,
      x: -10000,
      y: -10000,
    },
  },
};

const newContainer = {
  data: {
    name: 'New folder',
    children: [],
  },
  config: {
    collapsed: false,
  },
};

export default { newItem, newContainer };
